module.exports = __webpack_public_path__ + "static/img/10009 (1).0bd0f57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10009 (1).jpg
// module id = F7RF
// module chunks = 14